import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useDialogActions } from 'cityads-v3/hooks/dialog'
import { RootState } from 'cityads-v3/types/reducer'
import classes from './GetCodeButton.scss'

import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import GetCode, { GetCodeProps } from './GetCode'
import IconButton from '@mui/material/IconButton'
import LinkIcon from '@mui/icons-material/Link'
import Drawer from '@mui/material/Drawer'
import Tooltip from 'cityads-v3/components/Tooltip/Tooltip'

type GetCodeButtonProps = GetCodeProps & {}

export default function GetCodeButton({ id }: GetCodeButtonProps): JSX.Element {
  const { t } = useTranslation(['main'])
  const [open, setOpen, setClose] = useDialogActions()
  const isMobile = useSelector((state: RootState) => state.app.isMobile)

  return (
    <>
      <Tooltip isLight title={t('main:getCode')}>
        <IconButton onClick={setOpen} size="large">
          <LinkIcon />
        </IconButton>
      </Tooltip>

      {isMobile ? null : (
        <Dialog
          open={open}
          onClose={setClose}
        >
          <DialogContent classes={{ root: classes.dialogContent }}>
            <GetCode id={id} />
          </DialogContent>
        </Dialog>
      )}

      {isMobile ? (
        <Drawer
          classes={{
            paper: classes.drawerPaper
          }}
          anchor="bottom"
          open={open}
          onClose={setClose}
        >
          <GetCode id={id} />
        </Drawer>
      ) : null}
    </>
  )
}
